import { render, staticRenderFns } from "./toBeUpdateWeChat.vue?vue&type=template&id=105f790a&scoped=true"
import script from "./toBeUpdateWeChat.vue?vue&type=script&lang=js"
export * from "./toBeUpdateWeChat.vue?vue&type=script&lang=js"
import style0 from "./toBeUpdateWeChat.vue?vue&type=style&index=0&id=105f790a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f790a",
  null
  
)

export default component.exports